import { dew as _schemaUtilsDew } from "../builders/schema-utils";
import { dew as _maybeSkipValidationDew } from "./maybeSkipValidation";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.createIdentitySchemaCreator = void 0;
  const schema_utils_1 = _schemaUtilsDew();
  const maybeSkipValidation_1 = _maybeSkipValidationDew();
  function createIdentitySchemaCreator(schemaType, validate) {
    return () => {
      const baseSchema = {
        parse: validate,
        json: validate,
        getType: () => schemaType
      };
      return Object.assign(Object.assign({}, (0, maybeSkipValidation_1.maybeSkipValidation)(baseSchema)), (0, schema_utils_1.getSchemaUtils)(baseSchema));
    };
  }
  exports.createIdentitySchemaCreator = createIdentitySchemaCreator;
  return exports;
}